module.exports = __webpack_public_path__ + "img/image24.c86efd7f.jpg";